// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-data-protection-all-locations.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-data-protection-all-locations',
  title: 'Protect customer data at all storage locations including cloud and third parties',
  description:
    'Customer data must be protected in accordance with its assigned classification level regardless of where it is stored: physical media, internal servers, cloud environments or third-party systems. Data may only be shared via collaboration platforms (SharePoint, Teams, Slack, JIRA etc.) with explicit customer consent and direction.',
  category: 'assets',
  scfIds: ['SCF-DAT-001', 'SCF-DAT-002'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Data protection at all locations policy is published',
    },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
